import makeStyles from '@mui/styles/makeStyles';

export const useErrorPageStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    margin: theme.spacing(6.25),
    [theme.breakpoints.down('xl')]: {
      padding: theme.spacing(4.25)
    },
    [theme.breakpoints.down('lg')]: {
      padding: theme.spacing(2.25)
    }
  },
  heading: {
    textAlign: 'center',
    fontWeight: 500,
    [theme.breakpoints.down('xl')]: {
      fontSize: '6vh'
    },
    [theme.breakpoints.down('lg')]: {
      fontSize: '5vh'
    }
  },
  icon: {
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(2.5),
    [theme.breakpoints.down('xl')]: {
      height: '25vh'
    },
    [theme.breakpoints.down('lg')]: {
      height: '20vh'
    }
  },
  titleText: {
    [theme.breakpoints.down('xl')]: {
      fontSize: '4vh'
    },
    fontWeight: 600,
    [theme.breakpoints.down('lg')]: {
      fontSize: '3vh'
    }
  },
  subTitleText: {
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
    [theme.breakpoints.down('xl')]: {
      fontSize: '3vh',
      marginBottom: theme.spacing(2)
    },
    [theme.breakpoints.down('lg')]: {
      fontSize: '2vh',
      marginBottom: theme.spacing(2)
    }
  },
  button: {
    justifyContent: 'center'
  }
}));
